import { Link } from "react-router-dom";
import styles from "../styles/CategoryBar.module.css";

const CategoryBar = () => {
  return (
    <nav className={styles.bar}>
      <div className={styles.inner}>
        <Link to="/our-work/stairs">Stairs</Link>
        <Link to="/our-work/windows">Windows</Link>
        <Link to="/our-work/doors">Doors</Link>
        <Link to="/our-work/gates">Gates</Link>
        <Link to="/our-work/mouldings">Mouldings</Link>
        <Link to="/our-work/miscellaneous">Miscellaneous</Link>
        <Link to="/workshop">In the workshop</Link>
      </div>
    </nav>
  );
};

export default CategoryBar;
